import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramDoctorsPage } from './program-doctors';
import { DirectivesModule } from '../../directives/directives.module';
import { MatButtonModule, MatTableModule, MatFormFieldModule, MatInputModule, MatSortModule, MatPaginatorModule, MatIconModule } from '@angular/material';

@NgModule({
  declarations: [
    ProgramDoctorsPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramDoctorsPage),
    DirectivesModule,
    MatButtonModule, MatTableModule, MatFormFieldModule, MatInputModule, MatSortModule, MatPaginatorModule, MatIconModule
  ],
})
export class ProgramDoctorsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-doctors/program-doctors.module.ts